module.exports = __webpack_public_path__ + "img/c01_unittechhippikonchampion_Normal_ua.f5bb6850.webp";